import { z } from 'zod';

export const permissions = [
  'DASHBOARD_READ',
  'SLIDE_SCANS_READ',
  'SLIDE_SCANS_WRITE',
  'SETUP_READ',
  'SETUP_WRITE',
  'USER_MANAGEMENT_WRITE',
  'DATAPLANE_CONFIGURATION_WRITE',
  'DEMO',
] as const;

export const Permissions = z.enum([
  // This DEFAULT permission does not need to be defined in the permissions list in the database, but is put here for
  // consistency and ease-of-use.
  'DEFAULT',
  ...permissions,
]);

export type PermissionType = z.infer<typeof Permissions>;
